<div class="cell auto grid-y cell-block-y pageContainer">
    <div class="cell shrink grid-x grid-margin-x align-middle align-justify">
        <div class="cell shrink grid-y">
            <h1 class="cell shrink _primary" [i18nKey]="'decisions.dashboard.welcome'"></h1>
            <div class="cell shrink grid-x startGame">
                <div [routerLink]="'area'" class="cell shrink startGame-item" captureId="area-decision">
                    <i class="fas fa-city"></i><span [i18nKey]="'decisions.dashboard.area.decision'"></span>
                </div>
                <div class="cell shrink startGame-item" [routerLink]="'archetypes'"  captureId="archetype-decision"
                     *ngIf="isCurrentPeriodFirstPeriod">
                    <i class="fas fa-star"></i><span [i18nKey]="'decisions.dashboard.archetype.decision'"></span>
                </div>
            </div>
        </div>
        <div class="cell shrink currentPeriod" *ngIf="sessionCurrentPeriod">
            <i class="fas fa-calendar-day"></i>
            <div class="currentPeriodInfos">
                <span class="currentPeriodInfosLabel">Période courante</span>
                <kiwi-period [period]="sessionCurrentPeriod"></kiwi-period>
            </div>
        </div>
        <div class="cell shrink grid-x grid-margin-x">
            <kiwi-animator-select-team class="cell shrink"></kiwi-animator-select-team>
            <kiwi-all-periods-selector class="cell shrink"></kiwi-all-periods-selector>
        </div>
    </div>

    <kiwi-closed-decisions-banner *ngIf="decisionsClosed">
    </kiwi-closed-decisions-banner>

    <kiwi-spacer [size]="32"></kiwi-spacer>

    <div class="cell auto grid-x align-middle align-center">
        <div class="cell small-12 xxlarge-5 grid-x align-center align-stretch documentContainer _left">
            <div class="cell small-24 large-12 xxlarge-24" *ngFor="let studyCategory of studiesCategoriesLeft">
                <div class="documentContainer-item">
                    <fieldset>
                        <legend [i18nKey]="studyCategory.nameLabel"></legend>
                        <div class="documentContainer-item-content"
                             *ngFor="let studyLink of studyCategory.studiesLinks">
                            <span [routerLink]="studyLink.link" [captureId]="studyLink.name">{{'studies.' + studyLink.name | translate}}</span>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="cell small-auto xxlarge-shrink grid-y align-middle align-center decisionContainer">
            <div
                class="cell shrink grid-x align-middle align-center hide-for-small show-for-xxlarge xxlarge-up-3 teamDecisions">
                <div class="cell" [routerLink]="'menu'"  captureId="menu-decision">
                    <div class="teamDecisions-item _menu">
                        <span class="teamDecisions-item-icon"><i class="fas fa-clipboard-list"></i></span>
                        <span class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.menu.decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'communication'">
                    <div class="teamDecisions-item _communication">
                        <span class="teamDecisions-item-icon"><i class="fas fa-comments"></i></span>
                        <span
                            class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.communication.decision'"></span>
                    </div>
                </div>
            </div>
            <div
                class="cell shrink grid-x align-middle align-center hide-for-small show-for-xxlarge xxlarge-up-3 teamDecisions">
                <div class="cell" [routerLink]="'dining-rooms'">
                    <div class="teamDecisions-item _dining-rooms">
                        <span class="teamDecisions-item-icon"><i class="fas fa-utensils"></i></span>
                        <span
                            class="teamDecisions-item-name" capture-id="dining-rooms-decision" [i18nKey]="'decisions.dashboard.dining.rooms.decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'staff'">
                    <div class="teamDecisions-item _staff">
                        <span class="teamDecisions-item-icon"><i class="fas fa-user-tie"></i></span>
                        <span
                            class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.staff.decision'" [captureId]="'staff-decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'financial'">
                    <div class="teamDecisions-item _financial">
                        <span class="teamDecisions-item-icon"><i class="fas fa-file-invoice-dollar"></i></span>
                        <span
                            class="teamDecisions-item-name" capture-id="financial-decision" [i18nKey]="'decisions.dashboard.financial.decision'"></span>
                    </div>
                </div>
            </div>

            <div
                class="cell shrink grid-x align-middle align-center small-up-2 medium-up-3 xlarge-up-5 show-for-small hide-for-xxlarge teamDecisions">
                <div class="cell" [routerLink]="'menu'"  captureId="menu-decision">
                    <div class="teamDecisions-item _menu">
                        <span class="teamDecisions-item-icon"><i class="fas fa-clipboard-list"></i></span>
                        <span class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.menu.decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'communication'">
                    <div class="teamDecisions-item _communication">
                        <span class="teamDecisions-item-icon"><i class="fas fa-comments"></i></span>
                        <span
                            class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.communication.decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'dining-rooms'">
                    <div class="teamDecisions-item _dining-rooms">
                        <span class="teamDecisions-item-icon"><i class="fas fa-utensils"></i></span>
                        <span
                            class="teamDecisions-item-name"  capture-id="dining-rooms-decision" [i18nKey]="'decisions.dashboard.dining.rooms.decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'staff'">
                    <div class="teamDecisions-item _staff">
                        <span class="teamDecisions-item-icon"><i class="fas fa-user-tie"></i></span>
                        <span
                            class="teamDecisions-item-name"[i18nKey]="'decisions.dashboard.staff.decision'" [captureId]="'staff-decision'"></span>
                    </div>
                </div>
                <div class="cell" [routerLink]="'financial'">
                    <div class="teamDecisions-item _financial">
                        <span class="teamDecisions-item-icon"><i class="fas fa-file-invoice-dollar"></i></span>
                        <span
                            class="teamDecisions-item-name" capture-id="financial-decision" [i18nKey]="'decisions.dashboard.financial.decision'"></span>
                    </div>
                </div>
            </div>
            <div class="cell shrink decisionParameters"
                 capture-id="decisions-cloture"
                 [routerLink]="isAnimator? 'period-completion' : 'player-decisions-closure'">
                <span *ngIf="!isAnimator"[i18nKey]="'decisions.dashboard.decisions.closure'"></span>
                <span *ngIf="isAnimator"[i18nKey]="'decisions.dashboard.period.completion'"></span>
            </div>
        </div>
        <div class="cell small-12 xxlarge-5 grid-x align-center align-stretch documentContainer _right">
            <div class="cell small-24 large-12 xxlarge-24"
                 *ngFor="let studyCategory of studiesCategoriesRight">
                <div class="documentContainer-item">
                    <fieldset>
                        <legend [i18nKey]="studyCategory.nameLabel"></legend>
                        <div class="documentContainer-item-content"
                             *ngFor="let studyLink of studyCategory.studiesLinks">
                            <span [captureId]="studyLink.name" [routerLink]="studyLink.link">{{'studies.' + studyLink.name | translate}}</span>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>
